/** * this file was autogenerated by the icon-renderer module * the settings for this are in the nuxt.config.ts file *
if you would like to override the contents in this file you can create a custom component in the * assets/icons
directory and name it the same as the icon you would like to override * */
<template>
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="100%"
    viewBox="0 0 200 200"
    fill="unset"
    enable-background="new 0 0 200 200"
    xml:space="preserve"
  >
    <path
      fill="#9FF012"
      opacity="1.000000"
      stroke="none"
      d="
M201.000000,3.000000
	C201.000000,68.881950 201.000000,134.763901 201.000000,201.000000
	C185.647583,201.000000 170.292450,201.000000 154.417450,200.612274
	C154.829514,195.795929 155.761475,191.367310 156.797241,186.621582
	C156.902710,185.861649 156.904373,185.418793 157.107483,184.638916
	C157.159714,180.880814 157.010483,177.459778 156.888733,173.706848
	C156.829010,172.942047 156.741791,172.509125 156.753540,171.686493
	C155.543335,167.615753 154.234161,163.934738 152.805725,159.933914
	C151.710327,158.082977 150.734207,156.551865 149.823166,154.815613
	C149.888260,154.610474 149.889038,154.180405 149.827698,153.919678
	C149.491333,153.445953 149.216293,153.232941 148.771240,152.974792
	C148.601242,152.929657 148.261322,152.838989 148.207092,152.513489
	C147.106689,151.119507 146.060516,150.051010 145.007172,148.991272
	C145.000000,149.000000 145.017532,148.985687 144.933472,148.671539
	C143.566864,147.239273 142.284317,146.121155 140.841797,144.750259
	C139.867661,143.950287 139.053513,143.403107 138.216461,142.596039
	C138.147049,142.168533 138.100510,142.000931 137.961700,141.644745
	C137.703445,141.219208 137.484802,141.050507 137.161621,140.909882
	C137.109756,140.869736 137.111481,140.738541 137.100098,140.537552
	C137.088730,140.336563 136.975784,139.950119 136.962799,139.653168
	C137.000504,138.963379 137.051178,138.570541 137.336838,138.055542
	C137.680023,137.611404 137.788239,137.289444 138.057541,136.926239
	C138.218628,136.884995 138.547089,136.832794 138.889862,136.736237
	C139.430069,135.998291 139.627502,135.356903 139.868149,134.527496
	C139.911346,134.339493 140.110611,134.009079 140.333801,133.843384
	C140.645294,133.327667 140.733612,132.977646 140.842667,132.451050
	C140.863388,132.274445 141.095505,132.005020 141.326569,131.853561
	C141.648682,131.355499 141.739731,131.008881 141.856964,130.474899
	C141.883148,130.287521 142.136810,130.006729 142.356415,129.874420
	C142.685287,129.427216 142.794540,129.112320 142.922485,128.521790
	C142.992096,127.881973 143.043045,127.517799 143.316269,127.131226
	C143.538544,127.108818 143.969101,126.988586 144.238098,126.811562
	C144.638947,126.026741 144.770798,125.418953 144.918365,124.536362
	C144.991241,123.899742 145.048370,123.537918 145.330856,123.039803
	C145.632202,122.576691 145.708191,122.249870 145.885910,121.949783
	C145.987640,121.976517 146.180206,122.061234 146.384232,121.962173
	C146.825104,121.665672 147.005615,121.425827 147.338196,120.897240
	C147.577423,120.231865 147.608215,119.812828 147.634140,119.268112
	C147.629288,119.142433 147.828674,118.989075 148.115997,118.835159
	C148.510239,118.275253 148.617188,117.869255 148.701584,117.328354
	C148.679047,117.193443 148.871323,116.998878 149.150238,116.849716
	C149.612137,116.119377 149.795135,115.538200 149.949493,114.688980
	C149.854172,114.254021 149.787491,114.087120 149.827332,113.940704
	C149.933823,113.961182 150.132660,114.047867 150.355011,113.898048
	C150.678146,113.414818 150.778931,113.081398 150.893600,112.547607
	C150.907471,112.347221 151.127335,112.011002 151.345947,111.877197
	C151.678833,111.429337 151.793076,111.115280 151.954453,110.592133
	C152.001572,110.383049 152.212967,110.010155 152.418884,109.815796
	C152.666656,109.254311 152.708496,108.887184 152.742004,108.372131
	C152.733658,108.224197 152.925171,107.998062 153.188614,107.850311
	C153.642517,107.149582 153.832977,106.596611 154.004211,105.770645
	C153.928467,105.324196 153.871979,105.150719 154.010818,104.717239
	C154.556213,103.441238 154.906281,102.425240 155.451355,101.388077
	C155.646362,101.366905 156.034958,101.307816 156.260223,101.476173
	C156.658295,100.761292 156.831100,99.878052 157.000687,98.691132
	C157.035095,97.984680 157.072708,97.581902 157.321960,97.141068
	C157.533600,97.103012 157.945663,96.978958 158.316345,96.922226
	C159.318100,94.692482 159.949203,92.519470 160.575165,90.105515
	C160.631409,89.540787 160.769547,89.253975 161.246643,88.834015
	C161.654663,88.075363 161.800476,87.486824 161.977203,86.677048
	C162.008102,86.455818 162.211792,86.058205 162.547241,85.966446
	C166.137863,80.428596 168.309601,74.657173 168.538879,68.029060
	C169.241486,65.213623 169.595947,62.567036 169.966553,59.694038
	C169.982712,59.467628 170.138565,59.041252 170.470734,58.963448
	C170.811722,57.570347 170.820511,56.255051 170.807083,54.527061
	C170.924118,52.746613 171.063385,51.378849 171.348907,49.921623
	C171.546219,49.730522 171.665390,49.597126 171.635574,49.533207
	C171.545364,49.339703 171.397385,49.173130 171.224503,48.671143
	C171.244202,47.916859 171.311325,47.487488 171.725998,46.918648
	C171.752411,42.505501 171.431274,38.231831 171.041733,33.745270
	C170.973328,33.532372 170.957748,33.085419 170.993881,32.736507
	C170.678406,31.593988 170.326813,30.800379 169.766281,29.940113
	C169.557358,29.873455 169.125397,29.797514 169.111557,29.486454
	C169.001297,28.561317 168.904877,27.947237 168.853394,26.984468
	C168.476547,26.172544 168.054764,25.709312 167.756256,25.219048
	C167.879547,25.192019 167.652237,25.301783 167.729950,24.953167
	C167.166092,24.090271 166.524521,23.575993 165.627808,22.933681
	C164.915314,22.204216 164.457932,21.602781 163.972961,20.645304
	C159.889740,15.646132 154.481476,14.254848 148.639511,14.032088
	C144.857132,13.887864 141.152863,14.125029 139.012573,18.019911
	C139.000000,18.000000 139.037476,18.028448 138.713715,18.032919
	C137.971039,18.462938 137.552139,18.888487 137.002045,19.553883
	C136.295898,20.222176 135.720901,20.650618 134.799805,21.085846
	C133.996094,21.778442 133.538483,22.464252 132.985931,23.389412
	C132.768784,23.749317 132.646591,23.869869 132.395447,24.050598
	C132.106888,24.230190 132.009552,24.388033 131.819336,24.857254
	C131.136429,25.765915 130.608688,26.401623 129.727936,27.065460
	C128.277176,28.478285 126.913788,29.726767 126.123039,31.268875
	C118.712212,45.721584 117.144600,61.729721 114.151680,77.340858
	C113.751282,79.429367 114.653137,81.767532 115.002411,84.326431
	C114.990562,85.109703 114.928238,85.556633 114.604996,86.271454
	C113.569717,97.751160 112.608749,108.954094 112.073364,120.177322
	C111.535507,131.452164 114.284393,129.807846 101.906090,130.084412
	C98.793304,130.153961 97.958115,128.934021 97.904541,125.982460
	C97.763130,118.192101 97.372414,110.403450 96.904716,102.624710
	C96.829330,101.370865 95.849495,100.171394 95.210388,98.625450
	C95.153450,97.865303 95.173859,97.426498 95.445602,96.666588
	C95.785133,93.215363 96.248955,90.037125 95.855858,86.968658
	C95.462852,83.900993 94.212730,80.943123 93.231880,77.579201
	C93.101051,76.477821 93.076668,75.734375 93.323334,74.715927
	C92.680016,68.202309 92.073074,61.897030 90.740051,55.749187
	C89.892555,51.840645 90.344856,46.981083 85.232620,44.674450
	C84.013130,43.252918 83.026093,42.071068 81.937698,40.667816
	C81.624763,40.169697 81.345078,40.021698 80.998627,40.001205
	C81.000000,40.000000 80.997391,40.002815 80.949112,39.642513
	C73.449669,33.859547 65.137642,35.969406 57.065910,36.803852
	C55.284473,36.988014 53.676239,38.847630 51.741653,40.149384
	C50.673916,40.605572 49.852768,40.848106 48.847569,40.837914
	C47.111519,41.732555 45.559517,42.879932 43.911003,44.143997
	C43.814484,44.260693 43.515484,44.308979 43.154732,44.242332
	C42.191357,44.775654 41.588734,45.375618 40.992767,45.988457
	C40.999428,46.001324 40.975693,45.983734 40.615868,45.972595
	C39.164505,46.955727 38.072964,47.949997 36.891830,49.062614
	C36.802238,49.180965 36.510441,49.235653 36.191895,49.254509
	C35.564514,49.782455 35.255684,50.291542 34.833611,50.945717
	C34.720367,51.090797 34.370090,51.203911 33.992599,51.161129
	C32.461411,52.509945 31.307707,53.901543 30.046707,55.569633
	C29.268929,56.554424 28.598448,57.262714 27.605724,58.009666
	C26.824169,58.936085 26.364857,59.823841 25.744535,60.969391
	C25.040846,61.813599 24.498169,62.400013 23.619717,63.024467
	C22.965569,63.795639 22.647198,64.528778 22.212399,65.119553
	C22.095968,64.977196 22.311169,65.274323 21.957890,65.315353
	C19.419579,69.554207 17.009109,73.656090 15.161475,77.997505
	C14.431710,79.712242 14.955420,81.960449 14.933908,84.344833
	C14.913510,85.481636 14.867577,86.239349 14.585033,87.286400
	C13.845602,92.174904 14.394761,96.365005 19.050461,99.278427
	C20.837208,101.069275 22.384373,102.633087 24.014547,104.537384
	C33.845631,111.121330 43.050667,107.454445 51.947838,103.169617
	C53.162731,104.241676 54.135479,105.100060 55.195190,106.098724
	C55.282158,106.239014 55.325874,106.566231 55.247520,106.932495
	C55.894180,108.441193 56.619198,109.583618 57.227531,110.773048
	C57.110851,110.820045 57.357853,110.772278 57.275307,111.139076
	C58.132862,113.000534 59.072960,114.495201 60.222878,116.203583
	C60.698086,117.165855 60.963478,117.914391 61.217918,118.951019
	C61.479477,119.485107 61.751987,119.731110 62.248917,120.184525
	C62.750160,121.154549 63.026978,121.917152 63.231846,123.025337
	C63.590347,123.815941 64.020798,124.260963 64.605698,124.879776
	C64.928223,125.320396 65.033318,125.610069 65.039459,126.230522
	C65.267143,127.083267 65.530815,127.628090 65.843185,128.531677
	C66.606667,129.918579 67.321442,130.946701 68.019279,131.988312
	C68.002335,132.001801 68.029091,131.969910 68.023422,132.279053
	C68.382622,133.043823 68.747482,133.499435 69.285370,134.174072
	C69.899010,134.714294 70.339607,135.035522 70.836700,135.633987
	C71.073616,136.239380 71.254044,136.567551 71.395035,137.194809
	C71.868469,138.054764 72.381332,138.615616 72.946114,139.501160
	C73.170525,140.226913 73.343025,140.627991 73.395088,141.263153
	C73.286438,141.672348 73.298233,141.847458 73.059372,142.207092
	C72.218399,142.955078 71.628082,143.518539 70.702957,144.130524
	C66.964874,148.135391 63.561588,152.091766 60.020912,156.170700
	C59.883522,156.293243 59.764904,156.641815 59.466080,156.812042
	C57.815140,160.254562 56.463028,163.526886 54.955830,167.093277
	C54.616665,168.243134 54.432587,169.098907 53.884323,170.030991
	C43.716728,174.160797 39.899376,185.977539 45.120960,195.842484
	C45.968853,197.444382 46.384541,199.275070 47.000000,201.000000
	C31.694202,201.000000 16.388405,201.000000 1.000000,201.000000
	C1.000000,135.312454 1.000000,69.624886 1.464349,3.538949
	C45.503933,3.151758 89.079178,3.183811 132.654404,3.165553
	C155.436279,3.156008 178.218140,3.058035 201.000000,3.000000
z"
    />
    <path
      fill="#0C0D0C"
      opacity="1.000000"
      stroke="none"
      d="
M54.248512,169.954681
	C54.432587,169.098907 54.616665,168.243134 55.351521,167.162628
	C56.896339,166.210907 58.117538,165.656036 58.830086,164.715744
	C59.846622,163.374237 60.490387,161.750259 61.635078,160.209763
	C67.671944,154.574173 74.328728,150.715302 82.465073,152.286682
	C89.605995,153.665817 95.527130,151.890213 101.701614,148.650040
	C103.753868,147.573059 107.196053,148.759064 109.893387,149.383286
	C114.451668,150.438187 119.423912,153.802582 123.338501,152.787704
	C136.104630,149.478027 147.810165,155.756577 152.789337,169.389069
	C152.862473,170.129837 152.983139,170.546448 153.056854,171.414093
	C151.987411,176.645065 152.041138,182.034225 149.743881,186.092621
	C142.372787,199.114792 126.901962,200.534134 113.751274,189.725403
	C108.957581,184.379791 107.684509,178.174011 107.817345,171.411530
	C105.899109,171.411530 104.334526,171.411530 102.814888,171.411530
	C99.224037,193.959824 87.936226,201.390686 68.032486,194.190689
	C67.681534,196.505203 67.340767,198.752609 67.000000,201.000000
	C65.933334,201.000000 64.866661,201.000000 63.615173,200.666626
	C62.578320,199.268127 61.726288,198.202988 61.277164,197.641541
	C62.581127,195.360138 64.804413,193.035324 64.961441,190.578445
	C65.048500,189.216400 61.681934,187.633606 60.521065,186.682205
	C61.496964,184.792297 63.494465,182.515030 63.570004,180.175690
	C63.614685,178.792007 60.621151,177.310226 58.874619,175.767227
	C61.240124,171.343552 57.643917,170.718033 54.248512,169.954681
M135.334579,158.780914
	C126.898575,156.907288 119.864624,159.734253 116.111565,166.506714
	C112.556587,172.921722 113.519264,180.629318 118.531235,185.879807
	C123.193260,190.763718 130.185837,192.380066 136.395828,190.009262
	C142.722214,187.594025 146.966385,181.818588 147.080124,175.148758
	C147.214996,167.239746 143.283066,161.987488 135.334579,158.780914
M93.550034,183.827896
	C97.268913,177.725800 97.499695,171.452942 93.639801,165.471008
	C90.246323,160.211899 85.087395,157.710907 78.745537,158.041046
	C68.093857,158.595551 61.965832,167.776627 65.583237,177.627090
	C66.210388,179.334885 66.320457,181.277100 67.156372,182.852676
	C68.261864,184.936325 69.451271,187.350662 71.297020,188.599564
	C78.217339,193.282166 86.500938,191.526993 93.550034,183.827896
z"
    />
    <path
      fill="#F7F9F3"
      opacity="1.000000"
      stroke="none"
      d="
M53.884319,170.030991
	C57.643917,170.718033 61.240124,171.343552 58.874619,175.767227
	C60.621151,177.310226 63.614685,178.792007 63.570004,180.175690
	C63.494465,182.515030 61.496964,184.792297 60.521065,186.682205
	C61.681934,187.633606 65.048500,189.216400 64.961441,190.578445
	C64.804413,193.035324 62.581127,195.360138 61.277164,197.641541
	C61.726288,198.202988 62.578320,199.268127 63.215179,200.666626
	C57.977909,201.000000 52.955814,201.000000 47.466862,201.000000
	C46.384541,199.275070 45.968853,197.444382 45.120960,195.842484
	C39.899376,185.977539 43.716728,174.160797 53.884319,170.030991
z"
    />
    <path
      fill="#FBFFEB"
      opacity="1.000000"
      stroke="none"
      d="
M201.000000,2.499999
	C178.218140,3.058035 155.436279,3.156008 132.654404,3.165553
	C89.079178,3.183811 45.503933,3.151758 1.464349,3.070292
	C1.166667,2.333333 1.229735,1.149261 1.518317,1.091479
	C2.640014,0.866886 3.833333,1.000000 5.000000,1.000000
	C69.000000,1.000000 133.000000,0.993944 196.999969,1.041719
	C198.333542,1.042715 199.666672,1.666665 201.000000,2.499999
z"
    />
    <path
      fill="#FAFCF7"
      opacity="1.000000"
      stroke="none"
      d="
M113.877625,190.039398
	C126.901962,200.534134 142.372787,199.114792 149.743881,186.092621
	C152.041138,182.034225 151.987411,176.645065 153.371582,171.436874
	C154.707031,171.364502 155.680801,171.720367 156.654572,172.076233
	C156.741791,172.509125 156.829010,172.942047 156.632156,174.011230
	C156.534073,178.090317 156.720062,181.533142 156.906036,184.975952
	C156.904373,185.418793 156.902710,185.861649 156.455048,186.741974
	C154.672684,191.786301 153.336349,196.393158 152.000000,201.000000
	C137.645767,201.000000 123.291542,201.000000 108.333511,200.641602
	C108.728096,197.229004 109.726486,194.174835 111.038147,190.996124
	C112.193489,190.594208 113.035561,190.316803 113.877625,190.039398
z"
    />
    <path
      fill="#F6F6F5"
      opacity="1.000000"
      stroke="none"
      d="
M113.751274,189.725418
	C113.035561,190.316803 112.193489,190.594208 110.597862,191.003845
	C106.295555,191.136093 102.746803,191.136093 97.978966,191.136093
	C100.076714,195.257156 101.538353,198.128571 103.000000,201.000000
	C91.312439,201.000000 79.624878,201.000000 67.468658,201.000000
	C67.340767,198.752609 67.681534,196.505203 68.032486,194.190689
	C87.936226,201.390686 99.224037,193.959824 102.814888,171.411530
	C104.334526,171.411530 105.899109,171.411530 107.817345,171.411530
	C107.684509,178.174011 108.957581,184.379791 113.751274,189.725418
z"
    />
    <path
      fill="#10100F"
      opacity="1.000000"
      stroke="none"
      d="
M103.416664,201.000000
	C101.538353,198.128571 100.076714,195.257156 97.978966,191.136093
	C102.746803,191.136093 106.295555,191.136093 110.284592,191.128372
	C109.726486,194.174835 108.728096,197.229004 107.864853,200.641602
	C106.611107,201.000000 105.222221,201.000000 103.416664,201.000000
z"
    />
    <path
      fill="#EAFBC9"
      opacity="1.000000"
      stroke="none"
      d="
M152.333328,201.000000
	C153.336349,196.393158 154.672684,191.786301 156.351227,187.059082
	C155.761475,191.367310 154.829514,195.795929 153.948792,200.612274
	C153.555557,201.000000 153.111099,201.000000 152.333328,201.000000
z"
    />
    <path
      fill="#FAFCF7"
      opacity="1.000000"
      stroke="none"
      d="
M152.836884,169.064941
	C147.810165,155.756577 136.104630,149.478027 123.338501,152.787704
	C119.423912,153.802582 114.451668,150.438187 109.893387,149.383286
	C107.196053,148.759064 103.753868,147.573059 101.701614,148.650040
	C95.527130,151.890213 89.605995,153.665817 82.465073,152.286682
	C74.328728,150.715302 67.671944,154.574173 61.311302,159.963470
	C60.352180,158.716843 60.058540,157.679321 59.764904,156.641815
	C59.764904,156.641815 59.883522,156.293243 60.352745,156.124542
	C64.227226,151.997910 67.632492,148.039963 71.037750,144.082016
	C71.628082,143.518539 72.218399,142.955078 73.211899,142.138397
	C73.674438,141.790436 73.800491,141.677231 73.780357,141.604492
	C73.724747,141.403641 73.608063,141.219681 73.515526,141.029053
	C73.343025,140.627991 73.170525,140.226913 72.976990,139.192520
	C72.448799,138.004700 71.941643,137.450195 71.434479,136.895706
	C71.254044,136.567551 71.073616,136.239380 70.883728,135.250473
	C69.913239,133.054916 68.952202,131.520126 67.783569,129.800110
	C67.371208,129.101532 67.166420,128.588196 66.971657,127.759300
	C66.621742,126.975952 66.261818,126.508141 65.698517,125.988167
	C65.495140,125.935997 65.075439,125.922600 65.075439,125.922600
	C65.033318,125.610069 64.928223,125.320396 64.568329,124.577927
	C64.018936,123.628105 63.661369,123.153938 63.303795,122.679764
	C63.026978,121.917152 62.750160,121.154549 62.230415,119.909744
	C61.734623,119.172676 61.481747,118.917801 61.228874,118.662933
	C60.963478,117.914391 60.698086,117.165855 60.225040,115.863289
	C59.130875,113.796936 58.244362,112.284607 57.357849,110.772278
	C57.357853,110.772278 57.110851,110.820045 57.219299,110.442383
	C57.198383,109.413437 57.069016,108.762146 56.907730,107.868652
	C56.748638,107.309456 56.531723,107.075798 56.010666,106.809647
	C55.796272,106.693794 55.325874,106.566231 55.325874,106.566231
	C55.325874,106.566231 55.282158,106.239014 55.235104,105.772995
	C55.460117,104.541176 55.732185,103.775375 56.237255,102.917686
	C56.649593,102.551781 56.828930,102.277771 57.176224,101.730728
	C58.542755,100.631096 59.741329,99.804489 61.118347,99.297134
	C66.903679,112.624603 72.510574,125.632812 78.160797,138.741547
	C81.837387,137.227203 84.349442,135.785324 87.048912,135.182022
	C90.552094,134.399109 90.909500,132.461716 90.562782,129.406479
	C89.270195,118.016144 88.531105,106.552086 86.897026,95.214752
	C85.503777,85.548248 83.166534,76.017792 81.129112,65.838730
	C74.941269,74.495140 69.457390,82.174698 63.963432,89.847031
	C62.539421,91.835663 61.083847,93.801697 59.297585,95.787674
	C58.236923,96.205559 57.423573,96.503586 56.820580,97.038673
	C47.189972,105.584694 36.537827,109.357140 23.931538,104.196899
	C22.384373,102.633087 20.837208,101.069275 19.040501,98.918900
	C17.467855,94.553909 16.144749,90.775490 14.821643,86.997070
	C14.867577,86.239349 14.913510,85.481636 15.155437,84.059235
	C17.671343,77.354477 19.991255,71.314400 22.311169,65.274323
	C22.311169,65.274323 22.095968,64.977196 22.488916,65.006180
	C23.239738,64.352242 23.597612,63.669334 23.955490,62.986427
	C24.498169,62.400013 25.040846,61.813599 26.034422,60.878845
	C26.966202,59.677341 27.447084,58.824173 27.927967,57.971004
	C28.598448,57.262714 29.268929,56.554424 30.373081,55.488571
	C31.994530,53.821972 33.182308,52.512939 34.370090,51.203911
	C34.370090,51.203911 34.720367,51.090797 35.124935,50.886917
	C35.856483,50.200573 36.183464,49.718113 36.510441,49.235653
	C36.510441,49.235653 36.802238,49.180965 37.216217,49.040001
	C38.745361,47.927269 39.860527,46.955502 40.975693,45.983734
	C40.975693,45.983734 40.999428,46.001324 41.309578,45.962837
	C42.251644,45.385891 42.883564,44.847435 43.515484,44.308979
	C43.515484,44.308979 43.814484,44.260693 44.247475,44.124264
	C46.130848,43.022106 47.581234,42.056377 49.031620,41.090645
	C49.852768,40.848106 50.673916,40.605572 52.140408,40.166328
	C62.193672,36.545429 71.597488,36.608280 80.997391,40.002815
	C80.997391,40.002815 81.000000,40.000000 81.060486,40.254333
	C81.427010,40.635521 81.733032,40.762367 82.039062,40.889217
	C83.026093,42.071068 84.013130,43.252918 85.263550,45.022156
	C86.669243,49.017521 88.051231,52.366917 88.901657,55.846241
	C90.451515,62.187149 91.686150,68.605110 93.052292,74.990921
	C93.076668,75.734375 93.101051,76.477821 93.121735,78.006859
	C93.810120,84.857529 94.502197,90.922607 95.194267,96.987694
	C95.173859,97.426498 95.153450,97.865303 95.092514,99.081818
	C95.339523,109.633522 95.702141,119.406250 95.867912,129.182312
	C95.916397,132.041046 96.999290,132.939499 99.776260,132.741806
	C103.219360,132.496643 106.697906,132.463211 110.144608,132.647552
	C112.793633,132.789246 113.697136,131.715897 113.754814,129.223740
	C114.088203,114.816154 114.488358,100.410126 114.865913,86.003571
	C114.928238,85.556633 114.990562,85.109703 115.221237,83.999863
	C117.773132,63.914505 120.609215,44.610134 130.080948,27.037331
	C130.608688,26.401623 131.136429,25.765915 131.999695,24.874195
	C132.593369,24.467909 132.656433,24.258656 132.524384,23.990423
	C132.646591,23.869869 132.768784,23.749317 133.285065,23.304855
	C134.168060,22.346985 134.656982,21.713020 135.145905,21.079058
	C135.720901,20.650618 136.295898,20.222176 137.305878,19.507195
	C138.173065,18.823256 138.605270,18.425852 139.037476,18.028448
	C139.037476,18.028448 139.000000,18.000000 139.403107,17.975502
	C148.505402,13.935771 156.378952,16.469343 164.000549,21.001348
	C164.457932,21.602781 164.915314,22.204216 165.683411,23.231598
	C166.546844,24.205627 167.099533,24.753706 167.652237,25.301785
	C167.652237,25.301783 167.879547,25.192019 167.766464,25.536201
	C168.038406,26.364641 168.423431,26.848900 168.808441,27.333157
	C168.904877,27.947237 169.001297,28.561317 169.051071,29.794607
	C169.263062,30.949118 169.521713,31.484417 169.863541,32.252449
	C169.946732,32.485180 170.015900,32.974617 169.981934,33.333656
	C170.239059,34.799969 170.530167,35.907238 170.888733,37.465748
	C171.096939,40.964031 171.237686,44.011078 171.378448,47.058121
	C171.311325,47.487488 171.244202,47.916859 171.121750,48.919083
	C171.111832,49.664989 171.157242,49.838039 171.202652,50.011089
	C171.063385,51.378849 170.924118,52.746613 170.581360,54.707832
	C170.176010,55.843597 169.974182,56.385906 169.471054,57.152760
	C168.783661,59.924309 168.397583,62.471310 167.969131,65.248962
	C167.926758,65.479622 167.741058,65.910324 167.471191,65.970253
	C167.169556,66.700951 167.137802,67.371712 167.087341,68.370102
	C166.975830,69.124725 166.883011,69.551727 166.573517,70.181595
	C166.262421,70.955704 166.167999,71.526939 166.042938,72.326920
	C166.012283,72.555649 165.834137,72.981445 165.602539,73.173004
	C165.270203,73.942444 165.169449,74.520325 165.038452,75.406174
	C164.891159,76.108864 164.774124,76.503586 164.331421,77.023033
	C163.698288,78.471176 163.390839,79.794586 163.050659,81.459167
	C162.618515,82.861031 162.219131,83.921722 161.593109,85.170258
	C161.253052,85.921791 161.139633,86.485481 160.997559,87.375610
	C160.974075,88.136086 160.979248,88.570114 160.984436,89.004135
	C160.769547,89.253975 160.631409,89.540787 160.315247,90.226555
	C159.904434,90.700233 159.748383,90.811928 159.428711,91.075073
	C159.075653,91.478477 159.000473,91.760902 159.001556,92.295273
	C158.963547,92.516762 158.768494,92.921692 158.427246,93.031708
	C157.760788,94.487526 157.435562,95.833328 157.110336,97.179123
	C157.072708,97.581902 157.035095,97.984680 156.759552,98.784088
	C156.301514,99.445343 156.081421,99.709969 155.641098,100.150803
	C155.366028,100.687752 155.311188,101.048500 155.256348,101.409241
	C154.906281,102.425240 154.556213,103.441238 153.795624,104.833801
	C153.131424,105.456612 153.021988,105.755669 153.016418,106.422577
	C152.959106,107.157761 152.942139,107.577911 152.925171,107.998062
	C152.925171,107.998062 152.733658,108.224197 152.512115,108.458641
	C152.290573,108.693085 151.864746,108.938347 151.589142,108.978104
	C151.175903,109.675995 151.038284,110.334129 150.930252,111.252975
	C151.015656,111.679459 151.071487,111.845230 151.127335,112.011002
	C151.127335,112.011002 150.907471,112.347221 150.653473,112.685242
	C150.310532,113.364792 150.221603,113.706329 150.132660,114.047867
	C150.132660,114.047867 149.933823,113.961182 149.629501,114.065872
	C149.090561,114.412300 148.988617,114.700958 148.980988,115.363480
	C148.918869,116.126579 148.895096,116.562729 148.871323,116.998878
	C148.871323,116.998878 148.679047,117.193443 148.446655,117.510956
	C148.085724,118.215332 147.957199,118.602203 147.828674,118.989075
	C147.828674,118.989075 147.629288,119.142433 147.384003,119.375854
	C146.990845,119.715096 146.842957,119.820908 146.512207,120.065277
	C146.109619,120.445061 146.009109,120.728577 146.027634,121.311890
	C146.078354,121.733345 146.129272,121.897285 146.180206,122.061234
	C146.180206,122.061234 145.987640,121.976517 145.675613,122.095535
	C145.277557,122.535065 145.191528,122.855576 145.105499,123.176094
	C145.048370,123.537918 144.991241,123.899742 144.699615,124.563019
	C144.465134,124.864464 144.052353,125.019615 143.778137,125.186211
	C143.367294,125.953079 143.230652,126.553360 143.093994,127.153633
	C143.043045,127.517799 142.992096,127.881973 142.684052,128.639709
	C142.330261,129.357773 142.233536,129.682251 142.136810,130.006729
	C142.136810,130.006729 141.883148,130.287521 141.618500,130.621613
	C141.267731,131.305481 141.181625,131.655258 141.095520,132.005020
	C141.095505,132.005020 140.863388,132.274445 140.597702,132.504608
	C140.179306,132.802917 140.026596,132.871048 139.640686,133.091156
	C139.240891,133.758240 139.074326,134.273315 138.845200,135.129456
	C138.704132,135.924622 138.625610,136.378708 138.547089,136.832794
	C138.547089,136.832794 138.218628,136.884995 137.825165,137.049408
	C137.321747,137.535126 137.211792,137.856415 137.101868,138.177719
	C137.051178,138.570541 137.000504,138.963379 136.772858,139.720398
	C136.395126,140.275681 136.266235,140.506836 136.176331,141.134552
	C136.842087,141.946030 137.540710,142.400986 138.239349,142.855927
	C139.053513,143.403107 139.867661,143.950287 140.839722,145.124237
	C142.337601,146.829224 143.677567,147.907455 145.017532,148.985687
	C145.017532,148.985687 145.000000,149.000000 144.991730,149.366302
	C146.076096,150.768082 147.168701,151.803528 148.261322,152.838989
	C148.261322,152.838989 148.601242,152.929657 148.746094,153.250809
	C148.911957,153.755539 148.932983,153.939102 149.023773,154.323425
	C149.243500,154.785461 149.465012,154.950974 149.758072,155.020737
	C150.734207,156.551865 151.710327,158.082977 152.794739,160.316803
	C153.345612,162.849365 153.981369,164.662598 154.141113,166.516830
	C154.210541,167.322769 153.301514,168.212997 152.836884,169.064941
M146.735413,102.189949
	C149.007568,95.247536 151.870834,88.432243 153.398376,81.329689
	C155.202042,72.943176 156.402115,64.335449 156.823776,55.772411
	C157.153152,49.083530 153.613083,44.903179 148.611893,43.512318
	C143.784134,42.169685 138.792679,44.252316 135.313446,50.027527
	C132.682205,54.395149 129.951462,59.099701 128.974762,63.995411
	C125.568886,81.067245 122.743294,98.261826 120.049728,115.464966
	C119.112793,121.448906 119.201080,127.593369 118.843010,133.315033
	C123.439308,135.009521 127.272400,136.422653 131.634445,138.030792
	C136.626450,126.133026 141.503738,114.508705 146.735413,102.189949
z"
    />
    <path
      fill="#ACEA3E"
      opacity="1.000000"
      stroke="none"
      d="
M114.604996,86.271454
	C114.488358,100.410126 114.088203,114.816154 113.754814,129.223740
	C113.697136,131.715897 112.793633,132.789246 110.144608,132.647552
	C106.697906,132.463211 103.219360,132.496643 99.776260,132.741806
	C96.999290,132.939499 95.916397,132.041046 95.867912,129.182312
	C95.702141,119.406250 95.339523,109.633522 95.169876,99.403160
	C95.849495,100.171394 96.829330,101.370865 96.904716,102.624710
	C97.372414,110.403450 97.763130,118.192101 97.904541,125.982460
	C97.958115,128.934021 98.793304,130.153961 101.906090,130.084412
	C114.284393,129.807846 111.535507,131.452164 112.073364,120.177322
	C112.608749,108.954094 113.569717,97.751160 114.604996,86.271454
z"
    />
    <path
      fill="#ACEA3E"
      opacity="1.000000"
      stroke="none"
      d="
M129.727936,27.065462
	C120.609215,44.610134 117.773132,63.914505 115.170761,83.663528
	C114.653137,81.767532 113.751282,79.429367 114.151680,77.340858
	C117.144600,61.729721 118.712212,45.721584 126.123039,31.268875
	C126.913788,29.726767 128.277176,28.478285 129.727936,27.065462
z"
    />
    <path
      fill="#AFDF54"
      opacity="1.000000"
      stroke="none"
      d="
M56.004257,103.009583
	C55.732185,103.775375 55.460117,104.541176 55.148136,105.632706
	C54.135479,105.100060 53.162731,104.241676 51.947838,103.169617
	C43.050667,107.454445 33.845631,111.121330 24.014547,104.537384
	C36.537827,109.357140 47.189972,105.584694 56.820580,97.038673
	C57.423573,96.503586 58.236923,96.205559 59.491989,96.086044
	C60.334351,97.242523 60.637127,98.110207 60.939903,98.977882
	C59.741329,99.804489 58.542755,100.631096 56.941002,101.821198
	C56.359970,102.459663 56.182114,102.734627 56.004257,103.009583
z"
    />
    <path
      fill="#ACEA3E"
      opacity="1.000000"
      stroke="none"
      d="
M93.323334,74.715927
	C91.686150,68.605110 90.451515,62.187149 88.901657,55.846241
	C88.051231,52.366917 86.669243,49.017521 85.496002,45.261837
	C90.344856,46.981083 89.892555,51.840645 90.740051,55.749187
	C92.073074,61.897030 92.680016,68.202309 93.323334,74.715927
z"
    />
    <path
      fill="#ACEA3E"
      opacity="1.000000"
      stroke="none"
      d="
M80.949112,39.642513
	C71.597488,36.608280 62.193672,36.545429 52.387001,39.952679
	C53.676239,38.847630 55.284473,36.988014 57.065910,36.803852
	C65.137642,35.969406 73.449669,33.859547 80.949112,39.642513
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M163.972961,20.645306
	C156.378952,16.469343 148.505402,13.935771 139.415680,17.995411
	C141.152863,14.125029 144.857132,13.887864 148.639511,14.032088
	C154.481476,14.254848 159.889740,15.646132 163.972961,20.645306
z"
    />
    <path
      fill="#AFDF54"
      opacity="1.000000"
      stroke="none"
      d="
M21.957890,65.315353
	C19.991255,71.314400 17.671343,77.354477 15.129902,83.680145
	C14.955420,81.960449 14.431710,79.712242 15.161475,77.997505
	C17.009109,73.656090 19.419579,69.554207 21.957890,65.315353
z"
    />
    <path
      fill="#ACEA3E"
      opacity="1.000000"
      stroke="none"
      d="
M95.445602,96.666588
	C94.502197,90.922607 93.810120,84.857529 93.228188,78.364784
	C94.212730,80.943123 95.462852,83.900993 95.855858,86.968658
	C96.248955,90.037125 95.785133,93.215363 95.445602,96.666588
z"
    />
    <path
      fill="#E9FDC1"
      opacity="1.000000"
      stroke="none"
      d="
M70.702957,144.130524
	C67.632492,148.039963 64.227226,151.997910 60.490135,156.002014
	C63.561588,152.091766 66.964874,148.135391 70.702957,144.130524
z"
    />
    <path
      fill="#E9FDC1"
      opacity="1.000000"
      stroke="none"
      d="
M59.466080,156.812042
	C60.058540,157.679321 60.352180,158.716843 60.969597,160.000641
	C60.490387,161.750259 59.846622,163.374237 58.830086,164.715744
	C58.117538,165.656036 56.896339,166.210907 55.506607,166.868546
	C56.463028,163.526886 57.815140,160.254562 59.466080,156.812042
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M165.834137,72.981445
	C165.834137,72.981445 166.012283,72.555649 166.270630,72.131180
	C166.616043,71.130714 166.703125,70.554718 166.790192,69.978722
	C166.883011,69.551727 166.975830,69.124725 167.287552,68.349640
	C167.506454,68.001541 167.897690,67.906364 167.971649,67.978561
	C168.045593,68.050766 168.190735,68.197914 168.190735,68.197914
	C168.309601,74.657173 166.137863,80.428596 162.451172,85.696594
	C161.953018,85.339806 161.886368,85.161110 161.819733,84.982414
	C162.219131,83.921722 162.618515,82.861031 163.307083,81.243088
	C163.949875,79.423332 164.303482,78.160812 164.657089,76.898300
	C164.774124,76.503586 164.891159,76.108864 165.268021,75.210297
	C165.629944,74.131447 165.732040,73.556442 165.834137,72.981445
z"
    />
    <path
      fill="#EAFBC9"
      opacity="1.000000"
      stroke="none"
      d="
M152.789337,169.389069
	C153.301514,168.212997 154.210541,167.322769 154.141113,166.516830
	C153.981369,164.662598 153.345612,162.849365 152.914001,160.636612
	C154.234161,163.934738 155.543335,167.615753 156.753540,171.686493
	C155.680801,171.720367 154.707031,171.364502 153.418549,170.985870
	C152.983139,170.546448 152.862473,170.129837 152.789337,169.389069
z"
    />
    <path
      fill="#EAFBC9"
      opacity="1.000000"
      stroke="none"
      d="
M157.107498,184.638916
	C156.720062,181.533142 156.534073,178.090317 156.604660,174.343109
	C157.010483,177.459778 157.159714,180.880814 157.107498,184.638916
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M171.725983,46.918648
	C171.237686,44.011078 171.096939,40.964031 170.958679,37.087502
	C171.010834,35.491394 171.060486,34.724781 171.110138,33.958164
	C171.431274,38.231831 171.752411,42.505501 171.725983,46.918648
z"
    />
    <path
      fill="#AFDF54"
      opacity="1.000000"
      stroke="none"
      d="
M14.585033,87.286400
	C16.144749,90.775490 17.467855,94.553909 18.800919,98.691856
	C14.394761,96.365005 13.845602,92.174904 14.585033,87.286400
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M167.741058,65.910324
	C167.741058,65.910324 167.926758,65.479622 168.229599,65.012047
	C169.005096,63.003132 169.477737,61.461788 169.950394,59.920448
	C169.595947,62.567036 169.241486,65.213623 168.538879,68.029060
	C168.190735,68.197914 168.045593,68.050766 167.968719,67.643623
	C167.841583,66.794426 167.791321,66.352379 167.741058,65.910324
z"
    />
    <path
      fill="#ACEA3E"
      opacity="1.000000"
      stroke="none"
      d="
M48.847569,40.837914
	C47.581234,42.056377 46.130848,43.022106 44.343990,44.007568
	C45.559517,42.879932 47.111519,41.732555 48.847569,40.837914
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M159.592316,90.923622
	C159.748383,90.811928 159.904434,90.700233 160.320374,90.467506
	C159.949203,92.519470 159.318100,94.692482 158.339066,96.572754
	C158.250244,95.160576 158.509369,94.041130 158.768494,92.921692
	C158.768494,92.921692 158.963547,92.516762 159.204224,92.168747
	C159.683273,91.552795 159.732422,91.253761 159.592316,90.923622
z"
    />
    <path
      fill="#EBFEC2"
      opacity="1.000000"
      stroke="none"
      d="
M169.966553,59.694038
	C169.477737,61.461788 169.005096,63.003132 168.271973,64.781387
	C168.397583,62.471310 168.783661,59.924309 169.557480,57.500740
	C170.009659,58.096535 170.074112,58.568893 170.138565,59.041252
	C170.138565,59.041252 169.982712,59.467628 169.966553,59.694038
z"
    />
    <path
      fill="#ACEA3E"
      opacity="1.000000"
      stroke="none"
      d="
M33.992599,51.161129
	C33.182308,52.512939 31.994530,53.821972 30.480377,55.212070
	C31.307707,53.901543 32.461411,52.509945 33.992599,51.161129
z"
    />
    <path
      fill="#E8FDBF"
      opacity="1.000000"
      stroke="none"
      d="
M144.933472,148.671539
	C143.677567,147.907455 142.337601,146.829224 140.999710,145.377014
	C142.284317,146.121155 143.566864,147.239273 144.933472,148.671539
z"
    />
    <path
      fill="#E9FDC1"
      opacity="1.000000"
      stroke="none"
      d="
M67.991158,129.985321
	C68.952202,131.520126 69.913239,133.054916 70.827248,134.973236
	C70.339607,135.035522 69.899010,134.714294 69.262482,133.874252
	C68.720734,132.893600 68.374908,132.431747 68.029091,131.969910
	C68.029091,131.969910 68.002335,132.001801 68.025215,131.656342
	C68.029121,130.869034 68.010139,130.427185 67.991158,129.985321
z"
    />
    <path
      fill="#E8FDBF"
      opacity="1.000000"
      stroke="none"
      d="
M148.207092,152.513489
	C147.168701,151.803528 146.076096,150.768082 144.998917,149.357574
	C146.060516,150.051010 147.106689,151.119507 148.207092,152.513489
z"
    />
    <path
      fill="#AFDF54"
      opacity="1.000000"
      stroke="none"
      d="
M57.275307,111.139076
	C58.244362,112.284607 59.130875,113.796936 60.015221,115.649567
	C59.072960,114.495201 58.132862,113.000534 57.275307,111.139076
z"
    />
    <path
      fill="#ACEA3E"
      opacity="1.000000"
      stroke="none"
      d="
M40.615868,45.972595
	C39.860527,46.955502 38.745361,47.927269 37.305809,48.921654
	C38.072964,47.949997 39.164505,46.955727 40.615868,45.972595
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M170.470734,58.963448
	C170.074112,58.568893 170.009659,58.096535 169.858780,57.276192
	C169.974182,56.385906 170.176010,55.843597 170.603577,55.120522
	C170.820511,56.255051 170.811722,57.570347 170.470734,58.963448
z"
    />
    <path
      fill="#AFDF54"
      opacity="1.000000"
      stroke="none"
      d="
M67.783569,129.800110
	C68.010139,130.427185 68.029121,130.869034 68.042160,131.642868
	C67.321442,130.946701 66.606667,129.918579 65.920212,128.465469
	C65.948540,128.040497 66.097763,127.907356 66.310616,127.965302
	C66.523468,128.023239 66.961639,128.074844 66.961639,128.074844
	C67.166420,128.588196 67.371208,129.101532 67.783569,129.800110
z"
    />
    <path
      fill="#EBFEC2"
      opacity="1.000000"
      stroke="none"
      d="
M158.427246,93.031708
	C158.509369,94.041130 158.250244,95.160576 157.968384,96.629486
	C157.945663,96.978958 157.533600,97.103012 157.321960,97.141068
	C157.435562,95.833328 157.760788,94.487526 158.427246,93.031708
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M155.861328,99.974594
	C156.081421,99.709969 156.301514,99.445343 156.762756,99.087769
	C156.831100,99.878052 156.658295,100.761292 156.230530,101.140350
	C155.937485,100.415642 155.899399,100.195122 155.861328,99.974594
z"
    />
    <path
      fill="#AFDF54"
      opacity="1.000000"
      stroke="none"
      d="
M27.605724,58.009666
	C27.447084,58.824173 26.966202,59.677341 26.195433,60.621056
	C26.364857,59.823841 26.824169,58.936085 27.605724,58.009666
z"
    />
    <path
      fill="#AFDF54"
      opacity="1.000000"
      stroke="none"
      d="
M56.939648,108.110863
	C57.069016,108.762146 57.198383,109.413437 57.335983,110.395386
	C56.619198,109.583618 55.894180,108.441193 55.247520,106.932495
	C55.325874,106.566231 55.796272,106.693794 56.030499,107.056335
	C56.386009,107.750656 56.610981,107.981316 56.939648,108.110863
z"
    />
    <path
      fill="#ACEA3E"
      opacity="1.000000"
      stroke="none"
      d="
M134.799805,21.085846
	C134.656982,21.713020 134.168060,22.346985 133.380005,23.065506
	C133.538483,22.464252 133.996094,21.778442 134.799805,21.085846
z"
    />
    <path
      fill="#ACEA3E"
      opacity="1.000000"
      stroke="none"
      d="
M43.154732,44.242332
	C42.883564,44.847435 42.251644,45.385891 41.302917,45.949966
	C41.588734,45.375618 42.191357,44.775654 43.154732,44.242332
z"
    />
    <path
      fill="#E8FDBF"
      opacity="1.000000"
      stroke="none"
      d="
M150.900665,110.992256
	C151.038284,110.334129 151.175903,109.675995 151.676453,109.246071
	C152.097244,109.652893 152.155106,109.831520 152.212967,110.010155
	C152.212967,110.010155 152.001572,110.383049 151.702179,110.636292
	C151.235428,110.923775 151.068039,110.958015 150.900665,110.992256
z"
    />
    <path
      fill="#E9FDC1"
      opacity="1.000000"
      stroke="none"
      d="
M71.395035,137.194809
	C71.941643,137.450195 72.448799,138.004700 72.925079,138.867828
	C72.381332,138.615616 71.868469,138.054764 71.395035,137.194809
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M167.729950,24.953167
	C167.099533,24.753706 166.546844,24.205627 165.938538,23.359631
	C166.524521,23.575993 167.166092,24.090271 167.729950,24.953167
z"
    />
    <path
      fill="#EBFEC2"
      opacity="1.000000"
      stroke="none"
      d="
M171.041733,33.745270
	C171.060486,34.724781 171.010834,35.491394 170.891235,36.636261
	C170.530167,35.907238 170.239059,34.799969 170.217468,33.360405
	C170.487000,33.028111 170.957748,33.085419 170.957748,33.085419
	C170.957748,33.085419 170.973328,33.532372 171.041733,33.745270
z"
    />
    <path
      fill="#AFDF54"
      opacity="1.000000"
      stroke="none"
      d="
M23.619713,63.024467
	C23.597612,63.669334 23.239738,64.352242 22.605347,65.148529
	C22.647198,64.528778 22.965569,63.795639 23.619713,63.024467
z"
    />
    <path
      fill="#E8FDBF"
      opacity="1.000000"
      stroke="none"
      d="
M138.216461,142.596039
	C137.540710,142.400986 136.842087,141.946030 136.402466,141.144531
	C136.661469,140.797974 137.111481,140.738541 137.111481,140.738541
	C137.111481,140.738541 137.109756,140.869736 137.180176,141.147522
	C137.423462,141.748016 137.691254,141.884033 138.053970,141.833328
	C138.100510,142.000931 138.147049,142.168533 138.216461,142.596039
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M170.993881,32.736507
	C170.957748,33.085419 170.487000,33.028111 170.251450,33.001366
	C170.015900,32.974617 169.946732,32.485180 169.932587,31.921299
	C169.937378,30.907204 169.956284,30.456985 169.975204,30.006769
	C170.326813,30.800379 170.678406,31.593988 170.993881,32.736507
z"
    />
    <path
      fill="#AFDF54"
      opacity="1.000000"
      stroke="none"
      d="
M63.231850,123.025337
	C63.661369,123.153938 64.018936,123.628105 64.413879,124.404129
	C64.020798,124.260963 63.590347,123.815941 63.231850,123.025337
z"
    />
    <path
      fill="#AFDF54"
      opacity="1.000000"
      stroke="none"
      d="
M68.023422,132.279053
	C68.374908,132.431747 68.720734,132.893600 69.089447,133.655243
	C68.747482,133.499435 68.382622,133.043823 68.023422,132.279053
z"
    />
    <path
      fill="#E8FDBF"
      opacity="1.000000"
      stroke="none"
      d="
M138.907761,134.788391
	C139.074326,134.273315 139.240891,133.758240 139.700790,133.358521
	C140.032928,133.652267 140.071762,133.830673 140.110611,134.009079
	C140.110611,134.009079 139.911346,134.339493 139.640533,134.564087
	C139.369705,134.788696 138.907761,134.788391 138.907761,134.788391
z"
    />
    <path
      fill="#EBFEC2"
      opacity="1.000000"
      stroke="none"
      d="
M161.593109,85.170258
	C161.886368,85.161110 161.953018,85.339806 162.115723,85.788353
	C162.211792,86.058205 162.008102,86.455818 161.746552,86.710663
	C161.485016,86.965508 161.026199,87.049164 161.026199,87.049164
	C161.139633,86.485481 161.253052,85.921791 161.593109,85.170258
z"
    />
    <path
      fill="#AFDF54"
      opacity="1.000000"
      stroke="none"
      d="
M65.039459,126.230522
	C65.075439,125.922600 65.495140,125.935997 65.708755,126.301392
	C65.980843,127.080307 66.039299,127.493835 66.097763,127.907356
	C66.097763,127.907356 65.948540,128.040497 65.871513,128.106705
	C65.530815,127.628090 65.267143,127.083267 65.039459,126.230522
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M144.052353,125.019615
	C144.052353,125.019615 144.465134,124.864464 144.683884,124.837814
	C144.770798,125.418953 144.638947,126.026741 144.237488,126.482399
	C143.996017,125.893379 144.024185,125.456497 144.052353,125.019615
z"
    />
    <path
      fill="#E8FDBF"
      opacity="1.000000"
      stroke="none"
      d="
M143.778137,125.186211
	C144.024185,125.456497 143.996017,125.893379 143.968475,126.659424
	C143.969101,126.988586 143.538544,127.108818 143.316284,127.131226
	C143.230652,126.553360 143.367294,125.953079 143.778137,125.186211
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M160.997559,87.375610
	C161.026199,87.049164 161.485016,86.965508 161.715652,86.931892
	C161.800476,87.486824 161.654663,88.075363 161.246643,88.834015
	C160.979248,88.570114 160.974075,88.136086 160.997559,87.375610
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M138.713715,18.032919
	C138.605270,18.425852 138.173065,18.823256 137.437042,19.267345
	C137.552139,18.888487 137.971039,18.462938 138.713715,18.032919
z"
    />
    <path
      fill="#EBFEC2"
      opacity="1.000000"
      stroke="none"
      d="
M169.766281,29.940113
	C169.956284,30.456985 169.937378,30.907204 169.849396,31.688568
	C169.521713,31.484417 169.263062,30.949118 169.064911,30.105667
	C169.125397,29.797514 169.557358,29.873455 169.766281,29.940113
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M138.845200,135.129456
	C138.907761,134.788391 139.369705,134.788696 139.597321,134.752106
	C139.627502,135.356903 139.430069,135.998291 138.889862,136.736237
	C138.625610,136.378708 138.704132,135.924622 138.845200,135.129456
z"
    />
    <path
      fill="#ACEA3E"
      opacity="1.000000"
      stroke="none"
      d="
M36.191895,49.254509
	C36.183464,49.718113 35.856483,50.200573 35.238178,50.741833
	C35.255684,50.291542 35.564514,49.782455 36.191895,49.254509
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M149.150238,116.849716
	C148.895096,116.562729 148.918869,116.126579 149.220139,115.337448
	C149.497635,114.984474 149.978134,114.957031 149.978134,114.957031
	C149.795135,115.538200 149.612137,116.119377 149.150238,116.849716
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M153.188614,107.850311
	C152.942139,107.577911 152.959106,107.157761 153.257477,106.398483
	C153.538895,106.059364 154.023422,106.043633 154.023438,106.043633
	C153.832977,106.596611 153.642517,107.149582 153.188614,107.850311
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M168.853394,26.984467
	C168.423431,26.848900 168.038406,26.364641 167.643188,25.563232
	C168.054764,25.709312 168.476547,26.172544 168.853394,26.984467
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M137.100098,140.537552
	C137.111481,140.738541 136.661469,140.797974 136.435333,140.788010
	C136.266235,140.506836 136.395126,140.275681 136.785828,140.017365
	C136.975784,139.950119 137.088730,140.336563 137.100098,140.537552
z"
    />
    <path
      fill="#E9FDC1"
      opacity="1.000000"
      stroke="none"
      d="
M73.395088,141.263153
	C73.608063,141.219681 73.724747,141.403641 73.780357,141.604492
	C73.800491,141.677231 73.674438,141.790436 73.462555,141.953873
	C73.298233,141.847458 73.286438,141.672348 73.395088,141.263153
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M137.961700,141.644745
	C137.691254,141.884033 137.423462,141.748016 137.232056,141.187668
	C137.484802,141.050507 137.703445,141.219208 137.961700,141.644745
z"
    />
    <path
      fill="#E8FDBF"
      opacity="1.000000"
      stroke="none"
      d="
M149.949493,114.688980
	C149.978134,114.957031 149.497635,114.984474 149.258484,115.010498
	C148.988617,114.700958 149.090561,114.412300 149.523010,114.045387
	C149.787491,114.087120 149.854172,114.254021 149.949493,114.688980
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M148.953995,154.122665
	C148.932983,153.939102 148.911957,153.755539 148.916092,153.295959
	C149.216293,153.232941 149.491333,153.445953 149.594543,153.898132
	C149.422729,154.137314 148.953995,154.122665 148.953995,154.122665
z"
    />
    <path
      fill="#EAFBC9"
      opacity="1.000000"
      stroke="none"
      d="
M149.023773,154.323425
	C148.953995,154.122665 149.422729,154.137314 149.655884,154.158859
	C149.889038,154.180405 149.888260,154.610474 149.823166,154.815613
	C149.465012,154.950974 149.243500,154.785461 149.023773,154.323425
z"
    />
    <path
      fill="#ACEA3E"
      opacity="1.000000"
      stroke="none"
      d="
M132.395447,24.050598
	C132.656433,24.258656 132.593369,24.467909 132.154861,24.601242
	C132.009552,24.388033 132.106888,24.230190 132.395447,24.050598
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M150.355011,113.898048
	C150.221603,113.706329 150.310532,113.364792 150.639603,112.885620
	C150.778931,113.081398 150.678146,113.414818 150.355011,113.898048
z"
    />
    <path
      fill="#ACEA3E"
      opacity="1.000000"
      stroke="none"
      d="
M81.937698,40.667816
	C81.733032,40.762367 81.427010,40.635521 81.059113,40.255539
	C81.345078,40.021698 81.624763,40.169697 81.937698,40.667816
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M171.348907,49.921623
	C171.157242,49.838039 171.111832,49.664989 171.169174,49.244003
	C171.397385,49.173130 171.545364,49.339703 171.635574,49.533207
	C171.665390,49.597126 171.546219,49.730522 171.348907,49.921623
z"
    />
    <path
      fill="#E8FDBF"
      opacity="1.000000"
      stroke="none"
      d="
M155.641098,100.150803
	C155.899399,100.195122 155.937485,100.415642 156.005249,100.971992
	C156.034958,101.307816 155.646362,101.366905 155.451355,101.388077
	C155.311188,101.048500 155.366028,100.687752 155.641098,100.150803
z"
    />
    <path
      fill="#E8FDBF"
      opacity="1.000000"
      stroke="none"
      d="
M154.004196,105.770645
	C154.023422,106.043633 153.538895,106.059364 153.297821,106.083458
	C153.021988,105.755669 153.131424,105.456612 153.600281,105.093811
	C153.871979,105.150719 153.928467,105.324196 154.004196,105.770645
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M152.418884,109.815796
	C152.155106,109.831520 152.097244,109.652893 151.952057,109.206314
	C151.864746,108.938347 152.290573,108.693085 152.520462,108.606567
	C152.708496,108.887184 152.666656,109.254311 152.418884,109.815796
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M150.930252,111.252975
	C151.068039,110.958015 151.235428,110.923775 151.655060,110.845375
	C151.793076,111.115280 151.678833,111.429337 151.345947,111.877197
	C151.071487,111.845230 151.015656,111.679459 150.930252,111.252975
z"
    />
    <path
      fill="#E8FDBF"
      opacity="1.000000"
      stroke="none"
      d="
M137.336823,138.055542
	C137.211792,137.856415 137.321747,137.535126 137.664078,137.090652
	C137.788239,137.289444 137.680023,137.611404 137.336823,138.055542
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M148.115997,118.835159
	C147.957199,118.602203 148.085724,118.215332 148.469177,117.645859
	C148.617188,117.869255 148.510239,118.275253 148.115997,118.835159
z"
    />
    <path
      fill="#AFDF54"
      opacity="1.000000"
      stroke="none"
      d="
M61.217918,118.951019
	C61.481747,118.917801 61.734623,119.172676 62.005997,119.702324
	C61.751987,119.731110 61.479477,119.485107 61.217918,118.951019
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M146.695068,119.926712
	C146.842957,119.820908 146.990845,119.715096 147.388855,119.501526
	C147.608215,119.812828 147.577423,120.231865 147.281006,120.836754
	C147.015366,121.022598 146.899475,120.909164 146.875610,120.657883
	C146.799500,120.246635 146.747284,120.086670 146.695068,119.926712
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M146.384232,121.962173
	C146.129272,121.897285 146.078354,121.733345 146.248169,121.291504
	C146.468887,121.013603 146.899475,120.909164 146.899475,120.909164
	C146.899475,120.909164 147.015366,121.022598 147.072571,121.083084
	C147.005615,121.425827 146.825104,121.665672 146.384232,121.962173
z"
    />
    <path
      fill="#E8FDBF"
      opacity="1.000000"
      stroke="none"
      d="
M145.330872,123.039803
	C145.191528,122.855576 145.277557,122.535065 145.573883,122.068802
	C145.708191,122.249870 145.632202,122.576691 145.330872,123.039803
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M142.356415,129.874420
	C142.233536,129.682251 142.330261,129.357773 142.665390,128.915359
	C142.794540,129.112320 142.685287,129.427216 142.356415,129.874420
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M141.326569,131.853561
	C141.181625,131.655258 141.267731,131.305481 141.592316,130.808990
	C141.739731,131.008881 141.648682,131.355499 141.326569,131.853561
z"
    />
    <path
      fill="#ACEA3B"
      opacity="1.000000"
      stroke="none"
      d="
M140.333801,133.843384
	C140.071762,133.830673 140.032928,133.652267 139.934006,133.206512
	C140.026596,132.871048 140.179306,132.802917 140.576981,132.681213
	C140.733612,132.977646 140.645294,133.327667 140.333801,133.843384
z"
    />
    <path
      fill="#F9F9F9"
      opacity="1.000000"
      stroke="none"
      d="
M135.719116,158.887741
	C143.283066,161.987488 147.214996,167.239746 147.080124,175.148758
	C146.966385,181.818588 142.722214,187.594025 136.395828,190.009262
	C130.185837,192.380066 123.193260,190.763718 118.531235,185.879807
	C113.519264,180.629318 112.556587,172.921722 116.111565,166.506714
	C119.864624,159.734253 126.898575,156.907288 135.719116,158.887741
z"
    />
    <path
      fill="#FAFAFA"
      opacity="1.000000"
      stroke="none"
      d="
M93.320496,184.128265
	C86.500938,191.526993 78.217339,193.282166 71.297020,188.599564
	C69.451271,187.350662 68.261864,184.936325 67.156372,182.852676
	C66.320457,181.277100 66.210388,179.334885 65.583237,177.627090
	C61.965832,167.776627 68.093857,158.595551 78.745537,158.041046
	C85.087395,157.710907 90.246323,160.211899 93.639801,165.471008
	C97.499695,171.452942 97.268913,177.725800 93.320496,184.128265
z"
    />
    <path
      fill="#040405"
      opacity="1.000000"
      stroke="none"
      d="
M146.558228,102.537170
	C141.503738,114.508705 136.626450,126.133026 131.634445,138.030792
	C127.272400,136.422653 123.439308,135.009521 118.843010,133.315033
	C119.201080,127.593369 119.112793,121.448906 120.049728,115.464966
	C122.743294,98.261826 125.568886,81.067245 128.974762,63.995411
	C129.951462,59.099701 132.682205,54.395149 135.313446,50.027527
	C138.792679,44.252316 143.784134,42.169685 148.611893,43.512318
	C153.613083,44.903179 157.153152,49.083530 156.823776,55.772411
	C156.402115,64.335449 155.202042,72.943176 153.398376,81.329689
	C151.870834,88.432243 149.007568,95.247536 146.558228,102.537170
z"
    />
    <path
      fill="#060606"
      opacity="1.000000"
      stroke="none"
      d="
M61.118347,99.297134
	C60.637127,98.110207 60.334351,97.242523 59.837173,96.076477
	C61.083847,93.801697 62.539421,91.835663 63.963432,89.847031
	C69.457390,82.174698 74.941269,74.495140 81.129112,65.838730
	C83.166534,76.017792 85.503777,85.548248 86.897026,95.214752
	C88.531105,106.552086 89.270195,118.016144 90.562782,129.406479
	C90.909500,132.461716 90.552094,134.399109 87.048912,135.182022
	C84.349442,135.785324 81.837387,137.227203 78.160797,138.741547
	C72.510574,125.632812 66.903679,112.624603 61.118347,99.297134
z"
    />
    <path
      fill="#EBFEC2"
      opacity="1.000000"
      stroke="none"
      d="
M164.331421,77.023033
	C164.303482,78.160812 163.949875,79.423332 163.339844,80.901917
	C163.390839,79.794586 163.698288,78.471176 164.331421,77.023033
z"
    />
    <path
      fill="#EBFEC2"
      opacity="1.000000"
      stroke="none"
      d="
M167.471191,65.970253
	C167.791321,66.352379 167.841583,66.794426 167.894760,67.571426
	C167.897690,67.906364 167.506454,68.001541 167.306244,68.022011
	C167.137802,67.371712 167.169556,66.700951 167.471191,65.970253
z"
    />
    <path
      fill="#EBFEC2"
      opacity="1.000000"
      stroke="none"
      d="
M166.573532,70.181595
	C166.703125,70.554718 166.616043,71.130714 166.301270,71.902443
	C166.167999,71.526939 166.262421,70.955704 166.573532,70.181595
z"
    />
    <path
      fill="#EBFEC2"
      opacity="1.000000"
      stroke="none"
      d="
M165.602539,73.173004
	C165.732040,73.556442 165.629944,74.131447 165.298279,74.902321
	C165.169449,74.520325 165.270203,73.942444 165.602539,73.173004
z"
    />
    <path
      fill="#E9FDC1"
      opacity="1.000000"
      stroke="none"
      d="
M66.310616,127.965302
	C66.039299,127.493835 65.980843,127.080307 65.912132,126.353561
	C66.261818,126.508141 66.621742,126.975952 66.971657,127.759300
	C66.961639,128.074844 66.523468,128.023239 66.310616,127.965302
z"
    />
    <path
      fill="#EBFEC2"
      opacity="1.000000"
      stroke="none"
      d="
M159.428711,91.075073
	C159.732422,91.253761 159.683273,91.552795 159.242233,91.947250
	C159.000473,91.760902 159.075653,91.478477 159.428711,91.075073
z"
    />
    <path
      fill="#E9FDC1"
      opacity="1.000000"
      stroke="none"
      d="
M56.237259,102.917686
	C56.182114,102.734627 56.359970,102.459663 56.773048,102.094231
	C56.828930,102.277771 56.649593,102.551781 56.237259,102.917686
z"
    />
    <path
      fill="#E9FDC1"
      opacity="1.000000"
      stroke="none"
      d="
M56.907730,107.868652
	C56.610981,107.981316 56.386009,107.750656 56.244896,107.172188
	C56.531723,107.075798 56.748638,107.309456 56.907730,107.868652
z"
    />
    <path
      fill="#E8FDBF"
      opacity="1.000000"
      stroke="none"
      d="
M146.875610,120.657883
	C146.899475,120.909164 146.468887,121.013603 146.248352,121.033997
	C146.009109,120.728577 146.109619,120.445061 146.512207,120.065277
	C146.747284,120.086670 146.799500,120.246635 146.875610,120.657883
z"
    />
  </svg>
</template>

<script>
export default {
  name: 'Trackstar',
  inheritAttrs: true,
};
</script>
